import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowEdgeCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsBackEdge;
(function (NsBackEdge) {
    NsBackEdge.command = XFlowEdgeCommands.BACK_EDGE;
    NsBackEdge.hookKey = 'frontEdge';
})(NsBackEdge || (NsBackEdge = {}));
let BackEdgeCommand = 
/** 边后置命令(始终在画布最后方) */
class BackEdgeCommand {
    constructor() {
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.frontEdge.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const x6Graph = yield this.ctx.getX6Graph();
                const { edgeId } = handlerArgs;
                const x6Edge = x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.getCellById(edgeId);
                if (!x6Edge) {
                    console.error(edgeId, 'this edgeId is not exist');
                }
                else {
                    x6Edge.toBack();
                    /** frontEdge undo */
                    this.ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                        handlerArgs.commandService.executeCommand(XFlowEdgeCommands.FRONT_EDGE.id, {
                            edgeId,
                        });
                    })));
                }
                return {};
            }), runtimeHook);
            this.ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], BackEdgeCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BackEdgeCommand.prototype, "init", null);
BackEdgeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsBackEdge.command.id },
    })
    /** 边后置命令(始终在画布最后方) */
], BackEdgeCommand);
export { BackEdgeCommand };
//# sourceMappingURL=edge-back.js.map